import LegalPage from '../../components/LegalPage';
import CardNB from '../../components/ui-nb/CardNB';

export default function TermsPage() {
  const today = new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <LegalPage
      title="Términos de Servicio"
      lastUpdated={`Última actualización: ${today}`}
    >
      <CardNB>
        <div className="space-y-8">
          <p className="text-lg text-nb-text-secondary">
            Al crear una cuenta o usar Tellow Up! aceptas estos términos.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Descripción del Servicio</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! es una plataforma SaaS para gestión de reparaciones. Proporcionamos herramientas para dar seguimiento al estado de reparaciones, administrar técnicos y coordinar con clientes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Cuenta de Usuario</h2>
            <p className="text-nb-text-secondary">
              Debes proporcionar información veraz al crear tu cuenta. Eres responsable de mantener la confidencialidad de tus credenciales. Debes tener al menos 16 años para usar nuestro servicio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Organizaciones</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! permite a los usuarios crear o unirse a organizaciones (talleres). Los admins pueden invitar empleados y administrar permisos. Los usuarios son responsables de sus propias acciones dentro de la organización.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Códigos de Liberación</h2>
            <p className="text-nb-text-secondary">
              Un Código de Liberación es un identificador único que permite a los clientes dar seguimiento al estado de reparación sin crear una cuenta. Trata tu código como confidencial. Tellow Up! no es responsable por seguimiento no autorizado si compartes tu código.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Uso Aceptable</h2>
            <p className="text-nb-text-secondary">
              Aceptas no: (a) usar el servicio para fines ilegales; (b) intentar acceso no autorizado; (c) transmitir código malicioso; (d) interferir con las operaciones del servicio; (e) extraer o cosechar datos sin permiso.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Propiedad Intelectual</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! y su logo son marcas registradas. El software y contenido están protegidos por leyes de propiedad intelectual. Conservas la propiedad de los datos que envías pero nos otorgas una licencia para usarlos en la prestación del servicio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Pagos y Suscripciones</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! ofrece planes de suscripción para gestión de organizaciones. Los pagos se procesan de forma segura a través de Stripe. Autorizas a Stripe a cargar tu método de pago por todas las tarifas. Las suscripciones se renuevan automáticamente a menos que se cancelen. Puedes cancelar en cualquier momento desde tu cuenta.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Reembolsos</h2>
            <p className="text-nb-text-secondary">
              Todos los pagos se procesan a través de Stripe. Las solicitudes de reembolso se manejan según las políticas de Stripe. Contacta billing@tellowup.com para problemas relacionados con pagos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Cancelación</h2>
            <p className="text-nb-text-secondary">
              Puedes cancelar tu suscripción en cualquier momento. La cancelación toma efecto al final del período de facturación actual. No hay reembolsos por períodos parciales.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Limitación de Responsabilidad</h2>
            <p className="text-nb-text-secondary">
              TELLOW UP! SE PROPORCIONA "TAL CUAL" SIN GARANTÍAS. NO SOMOS RESPONSABLES POR DAÑOS INDIRECTOS, INCIDENTALES O CONSECUENTES. NUESTRA RESPONSABILIDAD TOTAL NO EXCEDERÁ EL MONTO QUE NOS HAYAS PAGADO EN LOS ÚLTIMOS DOCE MESES.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Modificaciones</h2>
            <p className="text-nb-text-secondary">
              Podemos modificar estos términos en cualquier momento. Te notificaremos por email o publicando un aviso en nuestro sitio web. El uso continuo después de modificaciones constituye aceptación.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Ley Aplicable</h2>
            <p className="text-nb-text-secondary">
              Para usuarios en México: estos términos se rigen por la ley mexicana. Para usuarios en Estados Unidos: estos términos se rigen por la ley federal y estatal aplicable de EE.UU. Para usuarios en Francia: estos términos se rigen por la ley francesa.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Contacto</h2>
            <p className="text-nb-text-secondary">
              Para preguntas sobre estos términos, contáctanos en:
            </p>
            <p className="mt-2 text-nb-text-secondary">
              <a href="mailto:legal@tellowup.com" className="text-nb-black font-bold underline">legal@tellowup.com</a>
            </p>
          </section>
        </div>
      </CardNB>
    </LegalPage>
  );
}
